<script>
  import { createEventDispatcher, onMount } from 'svelte';
  
  const dispatch = createEventDispatcher();
  
  export let mode = 'add'; // 'add' or 'edit'
  export let sectionId = '';
  export let section = null;
  
  let id = mode === 'edit' ? sectionId : '';
  let title = mode === 'edit' && section ? section.title : '';
  let text = mode === 'edit' && section ? section.text : '';
  
  // Close on escape key
  function handleKeydown(e) {
    if (e.key === 'Escape') {
      dispatch('close');
    }
  }
  
  function handleSave() {
    if (mode === 'add' && !id.trim()) {
      alert('Please enter a section ID');
      return;
    }
    
    dispatch('save', {
      id: id.trim(),
      title: title.trim(),
      text: text.trim()
    });
  }
  
  onMount(() => {
    document.addEventListener('keydown', handleKeydown);
    return () => {
      document.removeEventListener('keydown', handleKeydown);
    };
  });
</script>

<div class="modal-overlay" on:click={() => dispatch('close')}>
  <div class="modal-content" on:click|stopPropagation>
    <h3>{mode === 'add' ? 'Add New Section' : 'Edit Section'}</h3>
    
    <div class="form-styled">
      {#if mode === 'add'}
        <div class="field-wrapper">
          <label>Section ID</label>
          <input 
            type="text"
            bind:value={id}
            placeholder="e.g., intro, outro, custom-section"
          />
          <p class="field-help">
            Use 'intro' for introduction, 'outro' for conclusion, or any custom ID
          </p>
        </div>
      {/if}
      
      <div class="field-wrapper">
        <label>Title</label>
        <input 
          type="text"
          bind:value={title}
          placeholder="Section title"
        />
      </div>
      
      <div class="field-wrapper">
        <label>Text</label>
        <textarea 
          bind:value={text}
          placeholder="Section content"
          rows="4"
        ></textarea>
      </div>
      
      <div class="modal-actions">
        <button class="btn" on:click={() => dispatch('close')}>
          Cancel
        </button>
        <button class="btn btn-primary" on:click={handleSave}>
          {mode === 'add' ? 'Add Section' : 'Save Changes'}
        </button>
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 50;
  }
  
  .modal-content {
    background: #f3f2e3;
    border-radius: 10px;
    padding: 20px;
    width: 500px;
    max-width: 90%;
    border: 4px solid #d4d3bc;
    
    h3 {
      margin-bottom: 15px;
    }
  }
  
  .field-help {
    font-size: 11px;
    color: #6b7280;
    margin-top: 5px;
    font-style: italic;
  }
  
  .modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 20px;
    
    .btn {
      margin: 0;
    }
  }
  
  .btn-primary {
    background: #3b82f6;
    color: white;
    
    &:hover {
      background: #2563eb;
    }
  }
  
  textarea {
    height: auto;
    min-height: 80px;
    resize: vertical;
  }
</style>